import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  "i-frame": defineAsyncComponent(() => import("/app/layouts/iFrame.vue").then(m => m.default || m)),
  service: defineAsyncComponent(() => import("/app/layouts/service.vue").then(m => m.default || m))
}